/**
 * Define survey mixin
 *
 * @author minkyoung.park@emcast.com
 */
import loginApi from "@/api/loginApi.js";
export const surveyMixin = {
  methods: {
    // move prev route
    routerGoPrev() {
      if (this.$route.query.listType === "result") {
        this.$router.push({
          name: this.$route.matched[this.$route.matched.length - 2].name,
          params: this.$route.params,
          query: { listType: this.$route.query.listType }
        });
      } else {
        this.$router.push({
          name: this.$route.matched[this.$route.matched.length - 2].name,
          params: this.$route.params,
          query: this.$route.query
        });
      }
    },

    // 설문 종료 팝업 (popup survey close)
    closeSurvey() {
      this.$confirm({
        title: this.$t("716"), //설문 응답을 종료하시겠습니까?
        content: this.$t("717"), //설문 응답 종료 시 현재까지 응답한 내용은 제출되지 않습니다.
        accept: this.$t("719"), //확인
        cancel: this.$t("718") //취소
      })
        .then(() => {
          this.moveSurveyView();
        })
        .catch(() => {});
    },

    // 설문 상세로 이동(move Independent Survey Total View )
    moveSurveyView() {
      this.$router.push({
        name: "IndependentSurveyTotalView",
        params: { distId: this.$route.params.distId },
        query: this.$route.query
      });
    },

    // 설문 응시로 이동(move Independent Survey Take)
    moveSurveyTake() {
      this.$router.push({
        name: "IndependentSurveyTake"
      });
    },

    // 설문 결과로 이동(move Independent Survey Result)
    moveSurveyResult() {
      this.$router.push({
        name: "IndependentSurveyResult",
        params: {
          distId: this.$route.params.distId,
          respondentId: this.respondentId
        },
        query: this.$route.query
      });
    },

    // 설문 피드백으로 이동(move Independent Survey Feedback)
    moveSurveyFeedback() {
      this.$router.push({
        name: "IndependentSurveyFeedback",
        params: {
          distId: this.$route.params.distId,
          respondentId: this.respondentId
            ? this.respondentId
            : this.$route.params.respondentId
        },
        query: this.$route.query
      });
    },

    // 로그인 체크(check auth check)
    checkLogin() {
      return new Promise((resolve, reject) => {
        loginApi
          .validToken()
          .then(response => {
            resolve(true);
          })
          .catch(err => {
            resolve(false);
          });
      });
    },

    goBackToSurvey() {
      let routeName = "";
      if (this.$route.query.distributionType === "SATISFACTION") {
        if (this.$route.query.isMicro === true) {
          routeName = "/micro/";
        } else {
          routeName = "/learn/";
        }
        this.$router.push(
          routeName +
            this.$route.query.learnId +
            "?status=" +
            this.$route.query.status +
            "&tab=viewSurvey"
        );
      } else {
        this.$router.push({
          name: "IndependentSurveyTotalView",
          params: { distId: this.$route.params.distId },
          query: this.$route.query
        });
      }
    }
  }
};
